import { Component, ElementRef, inject, OnInit, ViewChild } from '@angular/core';


import { HttpClient } from '@angular/common/http';

import { anyU } from 'src/app/models/anyU';
import { environment } from 'src/environments/environment';
import { buyU } from 'src/app/models/buyU';
declare var bootstrap: any;


@Component({
  selector: 'app-buy',
  templateUrl: './buy.component.html',
  styleUrls: ['./buy.component.css']
})
export class BuyComponent {

  baseUrl = environment.apiBaseUrl;
  @ViewChild('userModal') userModal: ElementRef | undefined;

//u3
  @ViewChild('detailModal') detailModal!: ElementRef;
  detailObj: any = null;
  searchText: string = '';
  filteredList: any[] = [];

  anyList: any[] = [];
  anyObj: any ={
      "id":0,
      "witchbuy":"",
      "description":"",
      "buy_kind":"",

  }
  http = inject(HttpClient);

   ngOnInit(): void {
  this.getAllbuy()
  }

  // constructor(private userService: Service) {}
  openModal(): void {
  // console.log("openModal triggered");
  if (this.userModal) {
    const modal = new bootstrap.Modal(this.userModal.nativeElement);
    modal.show();
  } else {
    // console.warn("userModal is undefined!");
  }
}

//u3
openDetailModal(item: any): void {
  this.detailObj = item;

  const modal = new bootstrap.Modal(this.detailModal.nativeElement);
  modal.show();
}

closeModal(): void {
  if (this.userModal) {
    const modal = bootstrap.Modal.getInstance(this.userModal.nativeElement);
    if (modal) modal.hide();
  }
}

  getAllbuy(): void {
    this.http.get<buyU[]>(`${this.baseUrl}/buy`).subscribe((res) => {
      this.anyList = res;

      //u3
      this.filteredList = res;
      // console.log(this.anyList); // چاپ داده‌ها برای بررسی
    });
  }
 //u3
  onSearch(): void {
    const text = this.searchText.toLowerCase().trim();
    this.filteredList = this.anyList.filter(item =>
      item.witchbuy.toLowerCase().includes(text) ||
      item.description.toLowerCase().includes(text) ||
      item.buy_kind.toLowerCase().includes(text)
    );
  }

  onSave(): void {
  if (this.anyObj.id === 0) {
    // افزودن
    const newUser = { ...this.anyObj };
    delete newUser.id; // ← ID را حذف کن که نره به سرور
    this.http.post<buyU>(`${this.baseUrl}/buy`, newUser).subscribe((res) => {
      this.getAllbuy();
      this.closeModal();
    });
  } else {
    // ویرایش
    // this.http.put<anyU>(`${this.baseUrl}/mythings/${this.anyObj.id}`, this.anyObj).subscribe((res) => {

    this.http.post<buyU>(`${this.baseUrl}/buy/update`, this.anyObj).subscribe((res) => {
      this.getAllbuy();
      this.closeModal();
    });
  }
}


  // باز کردن مدال برای ویرایش
  openEditModal(user: any): void {
    this.anyObj = { ...user }; // پر کردن فیلدها با داده‌های کاربر انتخاب‌شده
    this.openModal();
  }

  // حذف خرید
  delete(Id: number): void {
    if (confirm("آیا مطمئن هستید که می‌خواهید این خرید را حذف کنید؟")) {
      // this.http.delete(`${this.baseUrl}/mythings/${Id}`).subscribe(() => {
        // this.http.post(`${this.baseUrl}/mythings/delete`, Id).subscribe(() => {
        this.http.post(`${this.baseUrl}/buy/delete/${Id}`, null).subscribe(() => {

        this.getAllbuy(); // بعد از حذف، لیست کاربران را مجدد بگیر
      });
    }
  }

  fixUrl(url: string): string {
  if (!url) return '';
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return url;
  }
  return 'http://' + url;
}


}


